
export class FilterTemplateRequestModel {
    TemplateId: number = 0;
    DetailViewId: number = 0;
}
